module.exports = __webpack_public_path__ + "img/logo-light.4b0bc55a.png";